module.exports = __webpack_public_path__ + "img/delayed_support_icon.adfd7e93.svg";